import styled from "styled-components";
import breakpoints from "../../../styles/breakpoints";
import { header, transition } from "../../../styles/variables";

/* The sticky page tab strip. On Capacitor we want it to extend up behind
 * the system status bar when scrolled, so products underneath don't bleed
 * through the notch. Achieved by:
 *   - shifting the sticky `top` up by env(safe-area-inset-top), which
 *     anchors the holder's top edge into the notch when stuck;
 *   - paying back the inset as `padding-top`, so the tab content still
 *     sits below the notch;
 *   - giving the holder the same background colour as the tab bar so the
 *     extended area is filled.
 * On web env() resolves to 0, so the layout is unchanged. */
export const TabHolder = styled.div<{
  isHeaderShown: boolean;
  smDownTop: string;
  bgColor: string;
}>`
  position: sticky;
  top: calc(${(props) => (props.isHeaderShown ? header.desktopHeight : "0px")} - env(safe-area-inset-top));
  padding-top: env(safe-area-inset-top);
  background-color: ${(props) => props.bgColor};
  z-index: 4;
  transition: ${transition.headerMenuBarTransition};
  ${breakpoints.mdDown} {
    top: calc(${(props) => (props.isHeaderShown ? header.mobileHeight : "0px")} - env(safe-area-inset-top));
  }
  ${breakpoints.smDown} {
    top: calc(${(props) => props.smDownTop} - env(safe-area-inset-top));
  }
`;
